var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02947 5.97053C6.89233 4.83348 5.04877 4.83348 3.91169 5.97053L1.85281 8.02947C0.715728 9.16653 0.715728 11.0101 1.85281 12.1472C2.9899 13.2843 4.83347 13.2843 5.97053 12.1472L7 11.1177M5.97053 8.02947C7.10767 9.16653 8.9512 9.16653 10.0883 8.02947L12.1472 5.97053C13.2843 4.83347 13.2843 2.9899 12.1472 1.85281C11.0101 0.715728 9.16653 0.715728 8.02947 1.85281L7 2.88225",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.be0644fa41c0334ed6582cfe46a57ef6.svg";
export { ForwardRef as ReactComponent };